import {createSlice} from "@reduxjs/toolkit";

interface BrokerStore {
    [topic: string] : any | null
}

const brokerSlice = createSlice({
    name: 'broker',
    initialState: {} as BrokerStore,
    reducers: {
        updateMessage(state, action) {
            const {topic, message} = action.payload
            state[topic] = message
        },
        clearMessage(state, action) {
            const {topic} = action.payload
            delete state[topic]
        }
    }
})

export const {updateMessage, clearMessage} = brokerSlice.actions

export default brokerSlice.reducer